import { Stack } from '@mantine/core';
import { PageTitle, Panel } from 'components/index';
import { Integration, PontoForm, type PontoFormFields } from 'shared/components/Integrations';

type PontoProps = {
  onSubmit: (data: PontoFormFields) => void;
};

export default function Ponto({ onSubmit }: PontoProps) {
  return (
    <>
      <PageTitle>
        <PageTitle.Back />
        {Integration.PONTO}
      </PageTitle>
      <Stack>
        <Panel>
          <PontoForm onSubmit={onSubmit} />
        </Panel>
      </Stack>
    </>
  );
}
